export default "__VITE_ASSET__399bdfc3__"